import { Drawer } from 'shared/antd'
import { FooterCard } from 'shared/common/Footer/ui/FooterCard/Mobile'
import { FooterLink } from 'shared/common/Footer/ui/FooterLink/Mobile'
import { FooterStoreBanner } from 'shared/common/Footer/ui/FooterStoreBanner/Mobile'

import { InfoType } from 'modules/Info/model/types'

import { Image } from 'shared/ui'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'

import { Copyright } from '../../Copyright/Mobile'
import { Support } from '../../Support/Mobile/Support'

import styles from './Footer.module.scss'

interface MobileFooterProps {
  isOpen: boolean
  onClose: () => void
}

const sellers = [
  {
    title: 'Стать партнером',
    href: '/landing-form',
  },
  {
    title: 'Личный кабинет',
    href: 'https://crm-market.mbank.kg/auth',
  },
  {
    title: 'MBusiness',
    href: 'https://smart.mbusiness.kg',
  },
]

const buyers = ['Помощь', 'Возврат товара']

const infoLinks = [
  {
    label: 'Пользовательское соглашение',
    href: ROUTER_PATHS.info.get(InfoType.userAgreement),
  },
  {
    label: 'Политика конфиденциальности',
    href: ROUTER_PATHS.info.get(InfoType.privacyPolicy),
  },
]

export function MobileFooter({ isOpen, onClose }: MobileFooterProps) {
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      type="secondary"
      className={styles.drawer}
    >
      <Image
        src={'/static/svg/market-logo.svg'}
        width={120}
        height={32}
        alt="market-logo"
        className={styles.logo}
      />
      <div className={styles.wrapper}>
        <FooterCard label="Продавцам">
          {sellers.map(({ title, href }) => (
            <FooterLink target="_blank" key={title} label={title} href={href} />
          ))}
        </FooterCard>

        <FooterCard label="Покупателям">
          {buyers.map(label => (
            <Support key={label} label={label} />
          ))}
        </FooterCard>

        <FooterCard label="Мы в социальных сетях">
          <FooterLink
            target="_blank"
            icon="instagram"
            label="Instagram"
            href="https://www.instagram.com/mbankkgz"
          />
        </FooterCard>

        <FooterCard label="Первый цифровой маркет с рассрочкой">
          {infoLinks.map(({ label, href }) => (
            <FooterLink key={label} label={label} href={href} />
          ))}
        </FooterCard>

        <FooterStoreBanner />

        <Copyright />
      </div>
    </Drawer>
  )
}
